<template>
  <!-- 退出答题提示 -->
  <van-dialog v-model="show" title :showConfirmButton="false">
    <van-icon name="cross" @click="close" />
    <div class="tp">
      <img src="@/assets/img/submitPrompt1.png" alt />
    </div>
    <p>未答题目:</p>
    <p class="ei" v-if="numdetail.danxuan.length>0">
      单选：
      <span style="color:red;" v-for="(e, i) in numdetail.danxuan" :key="i">
        <template v-if="i>0&&i<10">,</template>
        <template v-if="i<10">{{e}}</template>
        <template v-if="i==10">...</template>
      </span>
    </p>

    <p>
      已答题目:
      <span style="color:#2B8DF0; margin:0 10px;">{{qsTotalNum-noAnswer}}</span>题
    </p>
    <div class="footer">
      <van-button type="primary" @click="goOn">继续答题</van-button>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    noAnswer: {
      type: Number,
      default: 0
    },
    qsTotalNum: {
      type: Number,
      default: 0    
    },
    numdetail: {
      type: Object,
      default: {
        danxuan: [],
        duoxuan: [],
        jd: [],
        df: []
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      this.show = false
    },

    goOn() {
      this.show = false
    }
  },
  watch:{
    show(n){
      if(n) console.log(this.numdetail,111111);
      
    }
  }
}
</script>

<style lang='less' scoped>
.van-dialog {
  width: 652px;
  height: 788px;
  font-family: Source Han Sans SC;
  overflow: visible;
  // /deep/.van-dialog__header{
  //  display: none;
  // }
  .van-icon {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 40px;
    top: 32px;
  }

  /deep/.van-dialog__content {
    position: relative;
    padding-top: 330px;
    text-align: center;
    // height:100%;
    .tp {
      position: absolute;
      top: -240px;
      left: 50%;
      transform: translateX(-50%);
      width: 342px;
      height: 608px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    p {
      color: #333;
      font-size: 36px;
    }
    .footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      .van-button {
        width: 50%;
      }
      .van-button:first-child {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
